import makeUrl from '@/utils/makeUrl';
const carrierApiPre = `/api/carrier`;
const carrierApiList = [
	// 签到
	'sign',
	// 签退
	'unsign',
	// 订单列表
	'orderList',
	// 订单状态改变
	'statusChange',
	// 订单详情
	'orderDetail',
	// 配送统计
	'statement',
	// 扫码接单
	'receive',
	// 上传图片
	'uploadImg',
	// 获取骑手签到状态
	'carrierStatus',
	// 查看当前订单状态
	'orderStatus',
	// 统计订单数量
	'orderCountlist'
];
const carrierApi = {};

carrierApiList.forEach(key => {
	carrierApi[`${key}Url`] = makeUrl(carrierApiPre, key);
});

export default carrierApi;